export default (configuration?: string | { apiHost: string } | null) => {
  const apiHost = typeof configuration === 'object' && configuration !== null ? configuration.apiHost : configuration

  return {
    agents: `${apiHost}/v1/agents`,
    askV2: `${apiHost}/v2/ask`,
    assetsV2: `${apiHost}/v2/assets`,
    assetCookies: `${apiHost}/v1/cookies`,
    audit: `${apiHost}/v1/audit`,
    catalog: `${apiHost}/v1/catalog`,
    console: `${apiHost}${process.env.PUBLIC_URL}`,
    channelconnections: `${apiHost}/v1/admin/organizations/:organizationId/channel-connections`,
    feedback: `${apiHost}/v1/feedback`,
    knowledge: `${apiHost}/v1/knowledge`,
    knowledgeV2: `${apiHost}/v2/knowledge`,
    knowledgeBase: `${apiHost}/v1/knowledge-base`,
    publisher: `${apiHost}/v1/publisher`,
    publisherV2: `${apiHost}/v2/publisher`,
    tenant: `${apiHost}/v1/admin`,
    apps: `${apiHost}/v2/apps`,
    microapp: `${apiHost}/v1`,
    appbuilder: `${apiHost}/v1/appbuilder`,
    appbuilderV2: `${apiHost}/v2/appbuilder`,
    appbuilderV3: `${apiHost}/v3/appbuilder`,
    discover: `${apiHost}/v1/discover`,
    notificationSources: `${apiHost}/v1/sources`
  }
}
